import { Users } from '../../model/users';
import { AngularFireDatabase, FirebaseObjectObservable } from 'angularfire2/database';
import { Injectable } from '@angular/core';
import * as firebase from 'firebase'; 

@Injectable()
export class UserService {

  constructor(private db: AngularFireDatabase) { }

  save(user: firebase.User) {
    this.db.object('/users/' + user.uid).update({
      name: user.displayName,
      email: user.email,
      creationDate: new Date().toLocaleString()
    });
  }

  profileSave(user: firebase.User) {
    this.db.object('/seller-details/profiles' + user.uid).update({
      fullname: user.displayName,
      email: user.email,
      sellerId: user.uid
    });
  }

  saveCustomUser(user, sellerName){
    if(user.uid){
    this.db.object('/users/' + user.uid).update({
        name: sellerName,
        email: user.email,
        creationDate: new Date().toLocaleString()
      });
    }
  }

  get(uid: string): FirebaseObjectObservable<Users> { 
    return this.db.object('/users/' + uid);
  }

  deleteAll(sellerId) { 
    this.db.object('/products/' + sellerId ).remove();
    this.db.object('/banners/' + sellerId ).remove();
    this.db.object('/categories/' + sellerId ).remove();
    this.db.object('/map/' + sellerId ).remove();
    this.db.object('/seller-details/profiles/' + sellerId ).remove();
    this.db.object('/slides/' + sellerId ).remove();
    return this.db.object('/users/' + sellerId ).remove();
  
  }
}
